import _ from "lodash";
import update from "immutability-helper";
import client from "lib/apolloClient/client";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import {
  createNestedPlannerFieldsMutation,
  deletePlannerFieldMutation,
} from "modules/CommonMutations";
import {
  getProjectDetailsFromCache,
  writeProjectDetailsInCache,
} from "Projects/modules/ProjectGraphqlHelpers";
import { getProjectDetailsQuery } from "Projects/modules/ProjectQueries";

// Copied from src/routes/routes/Teacher/routes/Projects/modules/ProjectModules.js
// to avoid pulling in the whole ProjectModules chain.
const getCurrentProjectGroupDetails = ({ state }) => {
  const projectGroupDetails = _.get(state, "project.projectGroupDetails", {});
  return projectGroupDetails;
};

export const createNestedPlannerFields = ({
  parentFieldId,
  parentId,
  parentType,
  value,
}) => {
  return async (dispatch, getState) => {
    const refetchQueries = [];
    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    switch (parentType) {
      case "PROJECT": {
        const academicYearId = getSelectedAcademicYearId(getState());
        refetchQueries.push({
          query: getProjectDetailsQuery,
          variables: {
            id: parentId,
            studentProjectPortfolioFilter: {
              projectGroupTypes: [projectGroupType],
            },
            academicYearId,
            completionStatusFilters: {
              academicYearIds: [academicYearId],
            },
          },
        });
      }
    }
    try {
      await client.mutate({
        mutation: createNestedPlannerFieldsMutation,
        variables: {
          input: { parentFieldId, parentId, parentType, value },
        },
        awaitRefetchQueries: true,
        refetchQueries: refetchQueries,
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deletePlannerField = ({ fieldId, parentId, parentType }) => {
  return async (dispatch, getState) => {
    let parentData = null;
    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    const academicYearId = getSelectedAcademicYearId(getState());
    switch (parentType) {
      case "PROJECT": {
        parentData = getProjectDetailsFromCache({
          projectId: parentId,
          projectGroupType,
          academicYearId,
        });

        const fields = _.get(parentData, "node.fields", []);

        const parentFieldId = _.get(
          _.find(fields, { id: fieldId }),
          "parent",
          null
        );
        const parentObj = _.find(fields, { id: parentFieldId });

        const parentFieldIndex = _.findIndex(fields, { id: parentFieldId });
        const updateChildValue = _.filter(
          _.get(parentObj, "children", []),
          child => !_.isEqual(child, fieldId)
        );

        const updatedFields = update(fields, {
          [parentFieldIndex]: { children: { $set: updateChildValue } },
        });

        const filteredFields = _.filter(
          updatedFields,
          item => !_.isEqual(item?.id, fieldId)
        );

        writeProjectDetailsInCache({
          projectId: parentId,
          academicYearId,
          data: update(parentData, {
            node: {
              fields: { $set: filteredFields },
            },
          }),
          projectGroupType,
        });
      }
    }
    try {
      await client.mutate({
        mutation: deletePlannerFieldMutation,
        variables: {
          input: { plannerFieldId: fieldId },
        },
      });
    } catch (e) {
      switch (parentType) {
        case "PROJECT": {
          writeProjectDetailsInCache({
            projectId: parentId,
            data: parentData,
            projectGroupType,
            academicYearId,
          });
        }
      }
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};
